import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { TreatyUsersSearch } from '../../graphql/generated';
import { paginationDetails } from '../../utils/pagination-details/pagination-details';
import { pluralize } from '../../utils/pluralize/pluralize';

type UserSearchResultsSummaryProps = {
  name: TreatyUsersSearch['name'];
  total: number;
  currentPage: number;
  pageSize: number;
};

export const UserSearchResultsSummary: FC<UserSearchResultsSummaryProps> = ({
  name,
  total,
  currentPage,
  pageSize,
}) => {
  const pagination = paginationDetails(total, pageSize, currentPage);

  const noun = name ? 'result' : 'user';
  const pluralizedNoun = pluralize(noun, total);

  const nameSearchSummary = `${pagination} ${pluralizedNoun} for "${name}"`;
  const defaultSummary = `${pagination} ${pluralizedNoun}`;

  const summary = name ? nameSearchSummary : defaultSummary;

  return (
    <Text pt={2} pb={6} color="gray.600" data-testid="user-results-summary">
      {summary}
    </Text>
  );
};
